import Vue from 'vue'
import Router from 'vue-router'

//SYSTEM PAGES
import Login from './views/Login.vue'

// ADMIN PAGES
import AdminHome from './views/Admin.vue'
// REGIONAL MANAGER PAGES
import RegionalManagerHome from './views/RegionalManager.vue';
import RegionalWelcome from './components/regional-manager/Welcome';

// OPS MANAGER PAGES
import OpsManagerHome from './views/OpsManager.vue'
import OpsManagerWelcome from './components/opsmanager/Allocations.vue'
//import OpsManagerCustomerList from './components/opsmanager/customer/customer-list.vue'
import OpsManagerTaskList from './components/opsmanager/tasks/venue.vue'

//SUPERVISOR PAGES
import SupervisorHome from './views/Supervisor.vue'
import SupervisorWelcome from './components/supervisor/Welcome';
import Customers from './components/supervisor/customer/list'
import SupervisorInspections from './components/supervisor/inspections/supervisor-inspections'
import AllocateInspection from './components/supervisor/inspections/allocate-inspection'

//COMMON PAGES
import MeetingHome from './components/common/meetings/list.vue'
import MeetingCreate from './components/common/meetings/create.vue'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/Admin',
    name: 'AdminHome',
    component: AdminHome,
    children: []
  },
  {
    path: '/Main',
    name: 'RegionalManagerHome',
    component: RegionalManagerHome,
    children: [{
      path: '',
      name: 'RegionalManagerHome',
      component: RegionalWelcome
    },
    {
      path: 'Meeting',
      name: 'Meeting',
      component: MeetingHome
    },
    {
      path: 'Meeting/Create',
      name: 'MeetingCreate',
      component: MeetingCreate
    }
    ]
  },
  {
    path: '/OpsManager',
    name: '',
    component: OpsManagerHome,
    children: [{
      path: '',
      name: 'OpsManagerHome',
      component: OpsManagerWelcome,
    },
    // {
    //   path: 'Customers',
    //   name: 'Customers',
    //   component: OpsManagerCustomerList
    // },
    {
      path: 'Tasks/:allocationID/:venueID',
      name: 'Tasks',
      component: OpsManagerTaskList
    },
    {
      path: 'Meeting',
      name: 'Meeting',
      component: MeetingHome
    },
    {
      path: 'Meeting/Create',
      name: 'MeetingCreate',
      component: MeetingCreate
    }
    ]
  },
  {
    path: '/Supervisor',
    name: '',
    component: SupervisorHome,
    children: [{
      path: '',
      name: 'SupervisorHome',
      component: SupervisorWelcome,
    },
    {
      path: 'Customers',
      name: 'Customers',
      component: Customers,
    },
    {
      path: 'AllocateInspection',
      name: 'AllocateInspection',
      component: AllocateInspection,
    },
    {
      path: 'Inspections/Allocated/:venueID',
      name: 'SupervisorInspections',
      component: SupervisorInspections,
    },
    {
      path: 'Meeting',
      name: 'Meeting',
      component: MeetingHome
    },
    {
      path: 'Meeting/Create',
      name: 'MeetingCreate',
      component: MeetingCreate
    }
    ]
  },
  ]
})